import React from "react";
import { GuideMdxProvider } from "./src/components/guides/MdxProvider";

export const wrapRootElement = ({ element }) => (
  <GuideMdxProvider>{element}</GuideMdxProvider>
);

if (process.env.NODE_ENV !== "development") {
  console.log = () => {};
}

const ATTRIBUTION_KEY = "@neurosity/last-visited-urls";
const MAX_PAGES = 20;

export const onRouteUpdate = ({ location }) => {
  const path = location.pathname;

  try {
    const stored = sessionStorage.getItem(ATTRIBUTION_KEY);
    const pages = stored ? JSON.parse(stored) : [];

    // Don't add duplicate if user refreshes the same page
    if (pages[pages.length - 1] !== path) {
      pages.push(path);
    }

    const trimmed = pages.slice(-MAX_PAGES);
    sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(trimmed));
  } catch (e) {
    // sessionStorage may be unavailable (private browsing, etc.)
  }
};

export const shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition
}) => {
  // hack to override `shouldUpdateScroll` behavior to bypass jumping page to the top when changing between rent and buy
  if (location.search.includes("type=")) {
    return false;
  }
  const currentPosition = getSavedScrollPosition(location);
  return currentPosition || [0, 0];
};
